const LENDER = require('../constants/lenders');

const WARRANTY_PRICES = [
    {
        duration: 1,
        price: 699.0,
        limit: 0
    },
    {
        duration: 1,
        price: 799.0,
        limit: 7500
    },
    {
        duration: 1,
        price: 999.0,
        limit: 15000
    },
    {
        duration: 1,
        price: 1099.0,
        limit: 25000
    },
    {
        duration: 2,
        price: 999.0,
        limit: 0
    },
    {
        duration: 2,
        price: 1199.0,
        limit: 7500
    },
    {
        duration: 2,
        price: 1499.0,
        limit: 15000
    },
    {
        duration: 2,
        price: 1699.0,
        limit: 25000
    }
]

const LENDERS_FUNDING_WARRANTY = [
    LENDER.OODLE,
    LENDER.MONEYWAY,
    LENDER.BILLING,
    LENDER.LENDABLE,
    LENDER.MOTONOVO,
    LENDER.BNP,
    LENDER.BLUE,
    LENDER.STARTLINE,
    LENDER.V12,
    LENDER.MANNISLAND,
    LENDER.M247,
    LENDER.CREDITAGRICOLE,
    LENDER.NORTHRIDGEFINANCE,
    LENDER.MONEYBARN,
    LENDER.ZOPA
];


const LENDERS_FUNDING_WARRANTY_PCP = [
    LENDER.OODLE,
    LENDER.MONEYWAY,
    LENDER.BILLING,
    LENDER.LENDABLE,
    LENDER.MOTONOVO,
    LENDER.BNP,
    LENDER.BLUE,
    LENDER.STARTLINE,
    LENDER.V12,
    LENDER.MANNISLAND,
    LENDER.M247,
    LENDER.CREDITAGRICOLE,
    LENDER.NORTHRIDGEFINANCE,
    LENDER.MONEYBARN,
];

const LENDERS_NO_WARRANTY = [
    LENDER.ADVANTAGE,
    LENDER.CAMCO
];

const LENDERS_NO_WARRANTY_PCP = [
];

// Always put latest price first
const PAINT_PRICES = [
    349.00, 299.00, 279.00, 249.00, 199.0, 169.0
];

const LENDERS_FUNDING_PAINT = [
    LENDER.ALPHERA,
    LENDER.ADVANTAGE,
    LENDER.MONEYBARN,
    LENDER.OODLE,
    LENDER.SMF,
    LENDER.MONEYWAY,
    LENDER.BILLING,
    LENDER.LENDABLE,
    LENDER.MOTONOVO,
    LENDER.BNP,
    LENDER.BLUE,
    LENDER.STARTLINE,
    LENDER.V12,
    LENDER.MANNISLAND,
    LENDER.M247,
    LENDER.CREDITAGRICOLE,
    LENDER.AUTOMONEY,
    LENDER.ZOPA,
    LENDER.NORTHRIDGEFINANCE
];



const LENDERS_FUNDING_PAINT_PCP = [
    LENDER.ALPHERA,
    LENDER.ADVANTAGE,
    LENDER.MONEYBARN,
    LENDER.OODLE,
    LENDER.SMF,
    LENDER.MONEYWAY,
    LENDER.BILLING,
    LENDER.LENDABLE,
    LENDER.MOTONOVO,
    LENDER.BNP,
    LENDER.BLUE,
    LENDER.STARTLINE,
    LENDER.V12,
    LENDER.MANNISLAND,
    LENDER.M247,
    LENDER.CREDITAGRICOLE,
    LENDER.AUTOMONEY,
    LENDER.ZOPA,
    LENDER.NORTHRIDGEFINANCE
];

const LENDERS_NO_PAINT = [
    LENDER.CAMCO
];

const LENDERS_NO_PAINT_PCP = [
    LENDER.CAMCO
];
const COSMETIC_REPAIR_PRICES = [
    {
        duration: 3,
        price: 599.0
    }
]

const LENDERS_FUNDING_COSMETIC_REPAIR = [
    LENDER.OODLE,
    LENDER.MONEYWAY,
    LENDER.BILLING,
    LENDER.LENDABLE,
    LENDER.MOTONOVO,
    LENDER.BNP,
    LENDER.BLUE,
    LENDER.STARTLINE,
    LENDER.V12,
    LENDER.MANNISLAND,
    LENDER.M247,
    LENDER.CREDITAGRICOLE,
    LENDER.MONEYBARN,
    LENDER.NORTHRIDGEFINANCE
];


const LENDERS_FUNDING_COSMETIC_REPAIR_PCP = [
    LENDER.OODLE,
    LENDER.MONEYWAY,
    LENDER.BILLING,
    LENDER.LENDABLE,
    LENDER.MOTONOVO,
    LENDER.BNP,
    LENDER.BLUE,
    LENDER.STARTLINE,
    LENDER.V12,
    LENDER.MANNISLAND,
    LENDER.M247,
    LENDER.CREDITAGRICOLE,
    LENDER.MONEYBARN,
    LENDER.NORTHRIDGEFINANCE
];

const LENDERS_NO_COSMETIC_REPAIR = [
    LENDER.ADVANTAGE,
    LENDER.AUTOMONEY,
    LENDER.CAMCO
];

const LENDERS_NO_COSMETIC_REPAIR_PCP = [
    LENDER.ADVANTAGE,
    LENDER.AUTOMONEY,
    LENDER.CAMCO
];

module.exports = {
    WARRANTY_PRICES,
    LENDERS_FUNDING_WARRANTY,
    LENDERS_FUNDING_WARRANTY_PCP,
    LENDERS_NO_WARRANTY,
    LENDERS_NO_WARRANTY_PCP,
    PAINT_PRICES,
    LENDERS_FUNDING_PAINT,
    LENDERS_FUNDING_PAINT_PCP,
    LENDERS_NO_PAINT,
    LENDERS_NO_PAINT_PCP,
    COSMETIC_REPAIR_PRICES,
    LENDERS_FUNDING_COSMETIC_REPAIR,
    LENDERS_FUNDING_COSMETIC_REPAIR_PCP,
    LENDERS_NO_COSMETIC_REPAIR,
    LENDERS_NO_COSMETIC_REPAIR_PCP

};